export default {
      id: "ar_bibliotheque-usage",
      viewBox: "0 0 90 75",
      url: "../dist/images/" + "sprite.svg#ar_bibliotheque-usage",
      toString: function () {
        return this.url;
      }
    }